import { createAsyncThunk } from '@reduxjs/toolkit';
import { FAQProgramServices } from 'Services/axios/FAQProgram.Service';
import { toast } from 'react-toastify';
import { handleApiError } from 'Features/Common/ErrorHandler';

export const fetchFAQProgram = createAsyncThunk(
  'FAQProgram/fetchFAQProgram',
  async (filters) => {
    try {
      const response = await FAQProgramServices.getAll(filters);
      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const submitFAQProgram = createAsyncThunk(
  'addFAQProgram/submitFAQProgram',
  async (data) => {
    try {
      const formData = new FormData();
      formData.append('question', data?.question);
      formData.append('answer', data?.answer);
      formData.append('is_show', data?.is_show);
      let response;
      if (data.isUpdate) {
        response = await FAQProgramServices.update(data?.id, formData);
      } else {
        response = await FAQProgramServices.create(formData);
      }
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      data.successCallback && data.successCallback();
      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const deleteFAQProgram = createAsyncThunk(
  'deleteFAQProgram/deleteFAQProgram',
  async (id) => {
    try {
      const response = await FAQProgramServices.delete(id);
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const attachDetachFAQProgram = createAsyncThunk(
  'attachDetachFAQProgram/attachDetachFAQProgram',
  async (data) => {
    try {
      const formData = new FormData();
      data?.faqs?.forEach((faq) => {
        formData.append(`faqs[]`, faq?.value);
      });
      await FAQProgramServices.attachDetach(data.id, formData);
      return true;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

/* **************************************************** */
/* Pagination                                           */
/* **************************************************** */

export const handleBackPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
  if (pagination.current_page > 1) {
    dispatch(setFilters({
      ...filters,
      page: pagination.current_page - 1
    }));
    setRefetch(prevRefetch => !prevRefetch);
  }
}

export const handleNextPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
  if (pagination.current_page < pagination.last_page) {
    dispatch(setFilters({
      ...filters,
      page: pagination.current_page + 1
    }));
    setRefetch(prevRefetch => !prevRefetch);
  }
}

export const handleClickPagination = (page, filters, dispatch, setFilters, setRefetch) => {
  dispatch(setFilters({
    ...filters,
    page: page
  }));
  setRefetch(prevRefetch => !prevRefetch);
}